import { Input } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'

const SettingInput = ({ title, value, setValue, style }: any) => {
	return (
		<View
			style={{
				height: 45,
				width: '100%',
				borderBottom: '1px solid #ddd',
				padding: 3,
				...style,
			}}>
			<Input
				style={{ height: 30 }}
				value={value}
				placeholder={title}
				onChange={e => {
					setValue(e.target.value)
				}}
			/>
		</View>
	)
}

export default SettingInput
